import React from 'react'

export const BubbleIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style} className='icon--bubble'
    viewBox='0 0 32 32'
  >
    <path
      d='M25.8,26.7c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.3-0.3,0.2-0.6l-1.1-3.8c2.4-1.8,3.9-4.4,3.9-7c0-5.5-5.9-9.9-13.1-9.9 S2.9,9.7,2.9,15.2s5.9,9.9,13.1,9.9c2.1,0,4.2-0.4,6.1-1.1l3.4,2.6C25.6,26.7,25.7,26.7,25.8,26.7z M24.1,22.3l0.7,2.6L22.5,23 c-0.1-0.2-0.4-0.2-0.6-0.1c-1.8,0.8-3.9,1.2-6,1.2c-6.7,0-12.1-4-12.1-8.9s5.4-8.9,12.1-8.9s12.1,4,12.1,8.9c0,2.5-1.3,4.7-3.7,6.4 C24.1,21.8,24,22,24.1,22.3z'
    />
  </svg>
)
